module.exports = __webpack_public_path__ + "static/media/11-1.1f1d38ca.png";